import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const HomeIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 14 12">
    <path d="M5.33333 11.3333V7.33333H8V11.3333H11.3333V6H13.3333L6.66667 0L0 6H2V11.3333H5.33333Z" />
  </SvgIcon>
);
